import { render } from "./NutritionalInformation.vue?vue&type=template&id=30bea7e8"
import script from "./NutritionalInformation.vue?vue&type=script&lang=js"
export * from "./NutritionalInformation.vue?vue&type=script&lang=js"

import "./NutritionalInformation.vue?vue&type=style&index=0&id=30bea7e8&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__